import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ClientsPage from "./ClientsPage";
import CallbackRequestsPage from "./CallbackRequestsPage";
import AdminAccountsPage from "./AdminAccountsPage";
import ProjectsPage from "./ProjectsPage";
import AdminLayout from "../components/AdminLayout";
import DashboardOverview from "./DashboardOverview";

const sectionPaths = {
  Dashboard: "/admin/dashboard",
  Projects: "/admin/projects",
  Clients: "/admin/clients",
  "Callback Requests": "/admin/callbacks",
  "Admin Accounts": "/admin/accounts",
};

export default function AdminDashboard({ section = "Dashboard" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const clientSearch = location.state?.clientSearch || "";
  useEffect(() => {
    if (section === "Projects" && location.state?.scrollY != null) {
      const frame = window.requestAnimationFrame(() =>
        window.scrollTo({ top: location.state.scrollY, behavior: "auto" }),
      );
      return () => window.cancelAnimationFrame(frame);
    }
  }, [section, location.state]);
  // Preserve old project-return links while moving navigation into the URL.
  const legacyPath =
    location.pathname === "/admin/dashboard" &&
    sectionPaths[location.state?.activeItem];
  if (legacyPath && legacyPath !== location.pathname)
    return <Navigate to={legacyPath} replace state={location.state} />;
  const changeSection = (nextSection) => {
    if (sectionPaths[nextSection]) navigate(sectionPaths[nextSection]);
  };
  return (
    <AdminLayout
      activeItem={section}

    >
      <div className="dashboard-search-row">      {
        section === "Dashboard" ? (
          <label className="dashboard-header-search">
            <Search size={18} />
            <input
              type="search"
              aria-label="Search dashboard"
              placeholder="Search projects, clients, or updates…"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </label>
        ) : null
      }</div>
      {section === "Callback Requests" ? (
        <CallbackRequestsPage />
      ) : section === "Admin Accounts" ? (
        <AdminAccountsPage />
      ) : section === "Clients" ? (
        <ClientsPage initialSearch={clientSearch} />
      ) : section === "Projects" ? (
        <ProjectsPage />
      ) : (
        <DashboardOverview
          search={search}
          onSectionChange={changeSection}
          onClient={(client) =>
            navigate("/admin/clients", {
              state: { clientSearch: client.email || client.name },
            })
          }
        />
      )}
    </AdminLayout>
  );
}
